module.exports = __webpack_public_path__ + "static/img/BO.1a568854.png";